import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.2175 1.26904H14.4665L9.55314 6.8847L15.3333 14.5264H10.8075L7.26268 9.89174L3.20662 14.5264H0.956278L6.21161 8.51977L0.666656 1.26904H5.3074L8.51159 5.50526L12.2175 1.26904ZM11.4282 13.1802H12.6744L4.63025 2.54446H3.29296L11.4282 13.1802Z",
  fill: "black"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }